module.exports = __webpack_public_path__ + "img/venus-double.f1a45dbe.svg";